import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M10 .833V2.5m0 15v1.667M3.517 3.517 4.7 4.7m10.6 10.6 1.183 1.183M.833 10H2.5m15 0h1.667m-15.65 6.483L4.7 15.3M15.3 4.7l1.183-1.183M14.168 10a4.167 4.167 0 1 1-8.333 0 4.167 4.167 0 0 1 8.333 0"
    }, null, -1)
  ]))]))
}
export default { render: render }